// extracted by mini-css-extract-plugin
export default {"slideContainer":"ImageSection_slideContainer__s1RVc","wrapper":"ImageSection_wrapper__3tBEu","eachFade":"ImageSection_eachFade__s4KAl"};